//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// responsive
import { M, T } from "../../utils/MT";

// component
export default function MyPageLevelBox({ preOrder }) {
    // 마이페이지 사이드 메뉴
    // --프리오더일때는 이름과 회원레벨만 뜹니다!
    return (
        <>
            {preOrder ? (
                //  프리오더일때
                <LevelBoxWrap>
                    <NameBox>
                        <UserNameBox>
                            <Name>최신도</Name>
                            <span>님</span>
                            <MbBr /> <Text>반갑습니다 :&#41;</Text>
                        </UserNameBox>
                    </NameBox>
                    <LevelBox width100>
                        <LevelTitle>회원레벨</LevelTitle>
                        <LevelInfo>일반회원</LevelInfo>
                    </LevelBox>
                </LevelBoxWrap>
            ) : (
                // 프리오더 아닐 때
                <LevelBoxWrap>
                    <LevelBox>
                        <LevelTitle>회원레벨</LevelTitle>
                        <LevelInfo>일반회원</LevelInfo>
                    </LevelBox>
                    <LevelBox>
                        <LevelTitle>사용가능쿠폰</LevelTitle>
                        <LevelInfo>5</LevelInfo>
                    </LevelBox>
                    <LevelBox>
                        <LevelTitle>적립금</LevelTitle>
                        <LevelInfo>
                            5,000
                            <Won>원</Won>
                        </LevelInfo>
                    </LevelBox>
                </LevelBoxWrap>
            )}
        </>
    );
}

const LevelBoxWrap = styled.section`
    display: flex;
    align-items: center;

    width: 100%;
    background: #fafafa;
    min-height: calc(100vw * (117 / 1920));

    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        min-height: calc(100vw * (117 / 1300));

        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        flex-wrap: wrap;
        height: auto;

        background-color: transparent;

        min-height: auto;
    }
`;

const LevelBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(100vw * (280 / 1920));
    height: 100%;
    padding: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (280 / 1300));
        padding: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(214)};
        height: ${M(105)};
        padding: ${M(20)} ${M(25)};

        background: #fafafa;

        &:first-child {
            width: 100%;

            margin-bottom: ${M(10)};
        }

        ${({ width100 }) => {
            return (
                width100 &&
                `
                    width: 100%;
                `
            );
        }}
    }
`;

const LevelTitle = styled.span`
    font: calc(100vw * (15 / 1920)) "Noto-R";
    color: #555555;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};
    }
`;

const LevelInfo = styled.p`
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    font-family: "Noto-R";
    text-align: right;

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    margin-top: auto;

    font-size: calc(100vw * (33 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (33 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const Won = styled.span`
    font-size: calc(100vw * (20 / 1920));
    color: #aaa;

    margin-left: calc(100vw * (5 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
        margin-left: calc(100vw * (5 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-left: ${M(5)};
    }
`;

const NameBox = styled(LevelBox)`
    width: calc(100vw * (560 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (560 / 1300));
    }
    @media screen and (max-width: 900px) {
        width: 100%;
        height: auto;
    }
`;
const UserNameBox = styled.p`
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;

    & span:nth-of-type(2) {
        margin-right: calc(100vw * (20 / 1920));
        font: calc(100vw * (24 / 1920)) "Noto-R";
    }

    @media screen and (max-width: 1300px) {
        & span:nth-of-type(2) {
            margin-right: calc(100vw * (20 / 1300));
            font-size: calc(100vw * (24 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & span:nth-of-type(2) {
            margin-right: 0;
            font-size: ${M(14)};
        }
    }
`;
const Text = styled.span`
    font-size: calc(100vw * (25 / 1920));

    font-family: "Noto-R";
    color: #666666;

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        font-size: ${M(18)};

        margin-top: ${M(5)};
    }
`;

const Name = styled.span`
    font-size: calc(100vw * (40 / 1920));
    margin-right: calc(100vw * (10 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (40 / 1300));
        margin-right: calc(100vw * (10 / 1300));
    }
    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-right: ${M(5)};
    }
`;

const MbBr = styled.br`
    display: none;

    @media screen and (max-width: 900px) {
        display: block;
    }
`;
